import ServiceBusController from "servicestack/service-bus.controller";
import parserPrompt from "webmodals/parser/parser-prompt";
import labels from "webforms/formio/_labels";
import Formio from "webforms/formio/formio.model";
import FormSubmissionPrompt from "webforms/formio/formio-submission-prompt";

export default class FormioDetailsController extends ServiceBusController {
  constructor() {
    super();
    const $ctrl = this;
    $ctrl.colSplit = 3;
    $ctrl.ngModel = this;
    $ctrl.loading = new Date();
    $ctrl.$location = $ctrl.$ioc("$location");
    $ctrl.$localStorage = $ctrl.$ioc("$localStorage");
    Object.assign($ctrl, $ctrl.$localStorage.formioSettings, {
      labels,
      // formioDetailsPageItemUrl,
    });
  }

  $onInit() {
    const $ctrl = this;
    console.info("$onInit$formio", $ctrl);
    if (!$ctrl.formioId) {
      $ctrl.loadFormio("!");
      console.debug("$ctrl.formioId", $ctrl.formioId);
    } else {
      console.warn("$ctrl.formioId", $ctrl.formioId);
    }
  }

  $onChanges({ formioId }) {
    const $ctrl = this;
    console.info("$onChanges$formio", { formioId, $ctrl });
    if (
      formioId.currentValue &&
      formioId.perviousValue !== formioId.currentValue
    ) {
      $ctrl.loadFormio(formioId.currentValue);
    }
  }

  applySettings(args) {
    const $ctrl = this;
    $ctrl.loading = new Date();
    console.warn("$applySettings$formio", args);
    $ctrl.$localStorage.formioSettings = Object.assign(
      {},
      $ctrl.$localStorage.formioSettings,
      args
    );
    $resolve("$timeout")(
      () =>
        Object.assign(
          $ctrl,
          { ...args, loading: false },
          console.warn("applied", args)
        ),
      250
    );
  }

  enterRawJson() {
    const $ctrl = this;
    parserPrompt({
      delimiter: false,
      defaultValue: JSON.stringify(($ctrl.formio || {}).fields || {}, null, 2),
      rows: 16,
      title: "Replace Form Fields",
      subTitle: "Enter form.io JSON",
      label: "JSON",
    }).then((text) => {
      const formatted = text.join("");
      console.debug("$formio loaded", formatted, {
        text,
        formatted,
        fio: $ctrl.formio,
      });
      $ctrl.formio.fields = JSON.parse(formatted);
    });
  }

  addTag() {
    const $ctrl = this;
    if ($ctrl.newTagKind) {
      if (!$ctrl.formio.tags) {
        $ctrl.formio.tags = {};
      }
      $ctrl.formio.tags[$ctrl.newTagKind] = [];
      delete $ctrl.newTagKind;
    }
  }

  save() {
    const $ctrl = this;
    console.debug("$save", $ctrl);
    return $ctrl.bus
      .send(
        `${$ctrl.formio.create ? "Cre" : "Upd"}ateFormConfig.json`,
        $ctrl.formio
      )
      .then((saved) => {
        console.debug("$saved", saved);
        $ctrl.$state.go("^");
      });
  }

  $delete() {
    const $ctrl = this;
    console.debug("$delete", $ctrl);
    return $ctrl.bus
      .send(`DeleteFormConfig.json`, $ctrl.formio)
      .then((deleted) => {
        console.debug("$deleted", deleted);
        $ctrl.$state.go("^");
      });
  }

  loadFormio(formioId = this.formioId) {
    console.debug("$loadFormio", formioId);
    const $ctrl = this;
    console.debug("$loadFormio", { formioId, $ctrl });
    $ctrl.formio = false;
    return $ctrl.bus
      .send(`QueryFormConfigs/${formioId}.json`)
      .then(({ data }) => {
        const formio = data.results[0] || {
          create: true,
          id: formioId,
          active: true,
          label: "New Form  " + new Date(),
          fields: { components: [], display: "form", page: 0 },
        };
        $ctrl.formio = new Formio(formio);
        console.warn("$loadFormio", { data, formio, formioId, $ctrl });
        return $ctrl.bus
          .send(
            `QueryFormConfigHistory/${formio.euid}.json?OrderBy=-ModifiedOn`
          )
          .then(({ data: { results: history } }) => {
            $ctrl.history = history;
          });
      });
  }

  revert(history) {
    const $ctrl = this;
    return $ctrl.$modals
      .confirm(`${history.modifiedBy} @ ${history.modifiedOn}`, "Revert form?")
      .result.then(() => ($ctrl.formio.fields = history.fields));
  }

  preview(formio = this.formio) {
    const $ctrl = this;
    return FormSubmissionPrompt({
      formio,
      title: formio.label,
    }).then(() => $ctrl.query.load(true));
  }
}
